import React, { Component } from 'react';
import style from '../share/pageList.module.css';
import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
//import CheckBoxWithLabel from '../../components/CheckBoxWithLabel.js';
//import SearchBtn from '../../components/SearchBtn.js';
import DefaultBtn from '../../components/DefaultBtn.js';
import Paging from '../../components/Paging.js';
import TemplateV2 from '../../components/TemplateV2';
import BackDropLoading from '../../components/BackDropLoading.js';
import DataUpdate from './CompanyUpdate.js';
//import axios from 'axios';
import * as utils from '../../Utils.js';


import { Redirect } from 'react-router-dom'




// import logoImage from '../assets/images/header_logo.svg';
// import MenuLeft from './MenuLeft.js';
//import artwork from '../assets/images/artwork.svg';

class CompanyList extends Component {

    constructor(props) {
        //alert("Hotel");
        super(props);
        this.state = {
            redirectUrl: "",
            showCreate: false,
            showDelete: false,
            selectId: null,
            selectMethod: "",
            loading: true,
            dataObject: null,
            searchObject: {
                Name: ""
            },
            Page: 1
        };
    }
    componentDidMount() {
        //alert("test");
        this.props.appState.checkUser(this.props.appState);
        this.callGetData(1);
    }








    exportClick = () => {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/CompanyReportRequest";
        let data = {};

        data.searchObject = this.state.searchObject;

        if (this.props.site === "company") {
            data.companyId = this.props.appState.userObject.companyId;
        }

        let appState = this.props.appState;
        let token = appState.userObject.Token;
        data.Page = this.state.Page;

        utils.callPost(url, token, data, this.exportCallBack);
    }
    exportCallBack = (res) => {

        let url = process.env.REACT_APP_API_END_POINT + "/CompanyReport/ExcelReport/" + res.Data;

        let windowName = "";
        window.open(url, windowName, "height=500,width=500", "_blank");

        this.setState({
            loading: false
        })

    }















    callGetData = (page) => {
        let token = this.props.appState.userObject.Token;
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetCompanyList";
        let data = {};

        data.searchObject = { ...this.state.searchObject };
        data.Page = page;

        utils.callPost(url, token, data, this.callGetDataCallBack);

        this.setState({
            loading: true
        })

    }
    callGetDataCallBack = (res) => {
        let data = res.Data;
        //alert("reload");
        this.setState({
            dataObject: { ...data },
            loading: false
        })
    }

    handleChange = (e) => {
        //alert("change");
        let searchObject = { ...this.state.searchObject };
        if (e.target.name === "Name") searchObject.Name = e.target.value;

        this.setState({
            searchObject: searchObject,
        })
    }
    pagingClick = (page) => {
        this.callGetData(page);
    }
    searchClick = () => {
        this.callGetData(1);
    }
    showDelete(Id) {
        this.setState({
            showCreate: true,
            selectId: Id,
            selectMethod: "Delete"
        })
    }
    showEdit(Id) {
        this.setState({
            showCreate: true,
            selectId: Id,
            selectMethod: "Edit"
        })

        // let link = "/company/details/"+Id;

        // //alert(link);

        // //return <Redirect from="*" to="/hotels/" />

        // this.setState({
        //     redirectUrl:link
        // })


    }










    showDetail(Id, CompanyName) {
        // this.setState({
        //     showCreate: true,
        //     selectId: Id,
        //     selectMethod: "Edit"
        // })

        let userObject = this.props.appState.userObject;
        userObject.companyId = Id;
        userObject.companyName = CompanyName;
        window.localStorage.setItem("userObject", JSON.stringify(userObject));
        // let userObject = {appState}
        // console.log("debug");
        // console.log(appState);

        //let link = "/company/bookingreport/"+Id;

        let link = "/company/workflow/" + Id;



        this.setState({

            redirectUrl: link
        })


    }
    showCreate = () => {
        this.setState({
            showCreate: true,
            selectId: null,
            selectMethod: "Create"
        })
    }
    hideCreate = () => {
        //alert("hide");
        this.setState({
            showCreate: false,
            showDelete: false,
            selectId: null,
            selectMethod: "Create"
        })
        this.callGetData(1);
    }
    renderTable() {
        let tableRow = [];;
        let dataObject = this.state.dataObject;

        if (dataObject !== null) {
            console.log(dataObject);
            let dataList = dataObject.dataList;

            if (dataList !== undefined) {
                for (let i = 0; i < dataList.length; i++) {
                    let node = dataList[i];
                    let active = node.IsEnable === true ? "Enable" : "Disable";
                    let createAt = utils.stringToDateWithTime(node.CreateAt);

                    tableRow.push(
                        <tr key={node.Id}>
                            {/* <td onClick={(e) => this.showDetail(node.Id, node.CompanyName)} className={style.columnPointer}>{node.CompanyName}</td> */}


                            {/* <td>{node.HopInnSaleFirstName}</td>
                            <td>{node.HopInnSaleLastName}</td>
                            <td>{node.HopInnSaleEmail}</td> */}


                            {node.IsSubCompany !== true &&
                                <td  onClick={(e) => this.showDetail(node.Id, node.CompanyName)} className={style.columnPointer}><div className={style.columnMainCompany}>{node.CompanyName}</div></td>
                            }

                            {node.IsSubCompany === true &&
                                <td onClick={(e) => this.showDetail(node.Id, node.CompanyName)} className={style.columnPointer}><div className={style.columnSubCompany}>{node.MasterCompanyName} <i class="fa-solid fa-arrow-right"></i> {node.CompanyName}</div></td>
                            }




                           
                            {/* <td>{node.MasterCompanyName}</td> */}
                            {/* <td onClick={(e) => this.showDetail(node.Id, node.CompanyName)} className={style.columnPointer}>{node.CompanyName}</td> */}


                            <td>{node.RateCode}</td>
                            <td>{active}</td>
                            <td>{createAt}</td>
                            <td>
                                {/* <i className="fas fa-edit"></i> */}
                                <i onClick={(e) => this.showEdit(node.Id)} className="fas fa-edit"></i>
                                &nbsp; &nbsp; &nbsp; &nbsp;
                                <i onClick={(e) => this.showDelete(node.Id)} className="fas fa-trash-alt"></i>
                            </td>
                        </tr>
                    );
                }
            }

        }

        return (
            <div className={style.tableArea}>
                <table>
                    <thead>
                        <tr>
                            <th>Company Name</th>
                            {/* <th>Parent Company</th> */}

                            {/* <th>Hopinn sale firstname</th>
                            <th>Hopinn sale lastname</th>
                            <th>Hopinn sale email</th> */}
                            <th>Rate Code</th>
                            <th>Active</th>
                            <th>Create at</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>

                    <tbody>
                        {tableRow}
                    </tbody>


                </table>
                {dataObject !== null &&
                    <Paging dataObject={dataObject} onClick={this.pagingClick} />
                }
            </div>
        );
    }

    render() {
        let table = this.renderTable();

        if (this.state.redirectUrl !== "") {
            return <Redirect from="*" to={this.state.redirectUrl} />
        }


        return (
            <TemplateV2 appState={this.props.appState} page={"companylist"}>
                <div className={style.page}>
                    <BackDropLoading show={this.state.loading} key="hotel" />

                    <div className={style.navBar}>
                        <div className={style.nav}>Home</div>
                        <i className="fas fa-chevron-right"></i>
                        <div className={style.navSelect}>Company List</div>
                        {/* <i className="fas fa-chevron-right"></i>
                    <div className={style.navSelect}>Create</div> */}
                    </div>

                    {this.state.showCreate !== true && this.state.loading !== true && this.state.showDelete !== true &&

                        <>
                            <div className={style.searchArea}>
                                <div className={style.searchBox}>
                                    <div className={style.searchBoxInput}>
                                        <TextBoxWithLabel onChange={this.handleChange} value={this.state.searchObject.Name} name="Name" label="Company Name" />
                                    </div>
                                    <div className={style.searchBoxBtn}>
                                        <DefaultBtn label="Search" type="primary" onClick={this.searchClick} />
                                    </div>
                                    <div className={style.searchBoxBtn}>
                                        <DefaultBtn label="Export to excel" type="primary" onClick={this.exportClick} />
                                    </div>
                                </div>
                            </div>

                            <div className={style.contentArea}>
                                <div className={style.contentBox}>
                                    <div className={style.contentTitle}>Company List</div>

                                    <div className={style.line}></div>

                                    <div className={style.toolArea}>
                                        <div className={style.toolBtn} onClick={this.showCreate}>
                                            <i className="fas fa-plus"></i>
                                            Create
                                        </div>
                                    </div>
                                    <div className={style.line}></div>
                                    {table}
                                </div>
                            </div>
                        </>
                    }
                    {this.state.showCreate === true &&
                        <DataUpdate Id={this.state.selectId} onClose={this.hideCreate} method={this.state.selectMethod} appState={this.props.appState} />
                    }
                </div>
            </TemplateV2>

        );
    }
}
export default CompanyList